import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const toastStyle = {
    position: 'fixed',
    top: '24px',
    right: '24px',
    minWidth: '300px',
    maxWidth: '500px',
    padding: '16px 20px',
    borderRadius: '12px',
    background: 'var(--surface)',
    border: `2px solid ${type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : '#3b82f6'}`,
    boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    zIndex: 10000,
    animation: 'slideInRight 0.3s ease-out'
  };

  const iconStyle = {
    fontSize: '24px',
    flexShrink: 0
  };

  const contentStyle = {
    flex: 1,
    fontSize: '14px',
    fontWeight: '500',
    color: 'var(--text-primary)'
  };

  const closeButtonStyle = {
    background: 'transparent',
    border: 'none',
    color: 'var(--text-secondary)',
    cursor: 'pointer',
    fontSize: '20px',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '4px',
    transition: 'all 0.2s ease'
  };

  const icons = {
    success: '',
    error: '',
    info: '',
    warning: ''
  };

  return (
    <>
      <style>
        {`
          @keyframes slideInRight {
            from {
              transform: translateX(400px);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
      <div style={toastStyle}>
        <div style={iconStyle}>{icons[type]}</div>
        <div style={contentStyle}>{message}</div>
        <button
          style={closeButtonStyle}
          onClick={onClose}
          onMouseEnter={(e) => {
            e.target.style.background = 'var(--surface-light)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent';
          }}
        >
          ×
        </button>
      </div>
    </>
  );
};

export default Toast;